import PropTypes from "prop-types";
import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import Loader from "./Loader";
import formatPersonName from "../../helpers/formatPersonName";
import "./ConfirmActionModal.css";

const ConfirmActionModal = ({
  show,
  onConfirm,
  onClose,
  title,
  message,
  confirmText,
  confirmColor,
  isLoading,
  user,
  tenant,
}) => {
  const { t } = useTranslation();
  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={show}
      toggle={handleCloseModal}
      centered={true}
      className="confirm-action-modal"
    >
      <ModalBody className="confirm-action-modal-body">
        <div className="confirm-action-container">
          {/* Header */}
          <div className="confirm-action-header">
            <h3 className="confirm-action-title">{title}</h3>
            <p className="confirm-action-subtitle">{message}</p>
          </div>

          {/* User/Tenant Info Card */}
          {(user || tenant) && (
            <div className="info-card">
              {user && (
                <>
                  <div className="info-row">
                    <strong>{t("users.shared.confirmAction.user")}</strong>{" "}
                    {formatPersonName(user.firstName, user.lastName) ||
                      t("users.shared.confirmAction.notSet")}
                  </div>
                  <div className="info-row">
                    <strong>{t("users.shared.confirmAction.email")}</strong>{" "}
                    {user.email}
                  </div>
                </>
              )}
              {tenant && (
                <>
                  <div className="info-row">
                    <strong>{t("users.shared.confirmAction.tenant")}</strong>{" "}
                    {tenant.name}
                  </div>
                  {tenant.portalId && (
                    <div className="info-row">
                      <strong>
                        {t("users.shared.confirmAction.portalId")}
                      </strong>{" "}
                      {tenant.portalId}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* Action Buttons */}
          <div className="action-buttons">
            <Button
              type="button"
              color={confirmColor || "primary"}
              disabled={isLoading}
              onClick={onConfirm}
              className="btn-confirm"
            >
              {isLoading ? (
                <>
                  <Loader color="light" size="sm"></Loader>
                  <span className="ms-2">{t("common.processing")}</span>
                </>
              ) : (
                confirmText || t("common.actions.confirm")
              )}
            </Button>
            <Button
              type="button"
              onClick={handleCloseModal}
              disabled={isLoading}
              className="btn-cancel-action"
            >
              {t("common.actions.cancel")}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

ConfirmActionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  confirmColor: PropTypes.string,
  isLoading: PropTypes.bool,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
  }),
  tenant: PropTypes.shape({
    name: PropTypes.string,
    portalId: PropTypes.string,
  }),
};

export default ConfirmActionModal;
